export const sofiaNsaTranslations = {
  en: {
    breadcrumb: { home: 'Home', locations: 'Locations', nsa: 'Sofia, NSA' },
    hero: {
      badge: 'Sofia, NSA',
      heading: 'National Sports Academy',
      subheading: 'World-Class Athletics & Track & Field Training Facility',
      athletics: 'Athletics',
      trackField: 'Track & Field',
      district: 'Sofia, NSA district',
      stadiumSeating: 'Large stadium seating',
      sportsList: 'Athletics, Track & Field',
      stars: '5/5 stars',
      bookFacility: 'Book This Facility',
    },
    overview: {
      heading: 'Facility Overview',
      cards: [
        { heading: 'Institution Type', content: 'National Sports Academy', subtext: '75 years of excellence in sports education' },
        { heading: 'Capacity', content: 'Large Stadium Seating', subtext: 'Professional spectator facilities' },
        { heading: 'Surface', content: 'Professional Synthetic Track', subtext: 'IAAF standard competition surface' },
        { heading: 'Certification', content: 'International Standard', subtext: 'Meets IAAF requirements' },
      ],
    },
    about: {
      heading: 'About National Sports Academy',
      description: 'The National Sports Academy (NSA) is a specialised higher education institution in Bulgaria with 75 years of history. Located in Sofia, this prestigious academy features world-class athletics facilities and training grounds designed for elite-level competition and training.',
      keyHighlights: 'Key Highlights',
      highlights: [
        '75 years of excellence in sports education and training',
        '400m professional synthetic athletics track (IAAF standard)',
        'Comprehensive field events areas for all disciplines',
        'Indoor training facilities for year-round training',
        'Professional gym and strength & conditioning facilities',
        'State-of-the-art sports science laboratory',
        'Professional coaching staff with extensive experience',
        'Recovery facilities and medical support',
        'Ideal for training camps, competitions, and elite athlete development',
      ],
      testimonial: '"A prestigious institution with world-class facilities, perfect for elite athletics training and international competitions."',
      testimonialAttribution: 'Champion Maker Team',
    },
    sports: {
      heading: 'Available Sports & Activities',
      athletics: 'Athletics',
      athleticsDesc: 'Professional 400m synthetic athletics track meeting IAAF standards with 8 lanes, optimal surface for all weather conditions, and electronic timing systems.',
      viewSpecs: 'View Specifications',
      hideSpecs: 'Hide Specifications',
      trackSpecs: 'Track Specifications:',
      trackSpecsList: ['Track length: 400m (IAAF standard)', 'Lanes: 8 lanes', 'Surface: Professional synthetic track', 'Timing: Electronic timing systems', 'Weather: All-weather surface'],
      idealFor: 'Ideal For:',
      athleticsIdealFor: ['Elite athlete training camps', 'National team preparations', 'International competitions', 'Track events (sprints, middle distance, long distance)', 'Relay training and competitions'],
      trackField: 'Track & Field',
      trackFieldDesc: 'Comprehensive field events areas with dedicated facilities for all throwing and jumping disciplines, meeting international competition standards.',
      fieldEventsAvailable: 'Field Events Available:',
      fieldEventsList: ['Long jump and triple jump pits', 'High jump and pole vault areas', 'Shot put, discus, javelin, hammer throw circles', 'All areas meet IAAF competition standards', 'Professional equipment and safety measures'],
      fieldIdealFor: ['Field event specialist training', 'Multi-event competitions (decathlon/heptathlon)', 'Technical skill development', 'Competition preparation', 'Year-round training programs'],
    },
    amenities: {
      heading: 'World-Class Facilities & Amenities',
      items: [
        { title: 'Professional Coaching', desc: 'Access to experienced coaching staff with extensive athletics expertise' },
        { title: 'Equipment Storage', desc: 'Secure storage areas for athletics equipment and personal belongings' },
        { title: 'Stadium Seating', desc: 'Large stadium with professional spectator seating and excellent views' },
        { title: 'Parking Available', desc: 'Convenient parking facilities for teams and visitors' },
        { title: 'Strength & Conditioning Gym', desc: 'Professional gym facilities for athletic performance training' },
        { title: 'WiFi Available', desc: 'High-speed wireless internet throughout the facility' },
        { title: 'Cafeteria Services', desc: 'On-site refreshments and meal options available' },
        { title: 'Medical Facilities', desc: 'Comprehensive medical support and first aid facilities' },
        { title: 'Sports Science Lab', desc: 'State-of-the-art laboratory for performance analysis and testing' },
        { title: 'Electronic Timing Systems', desc: 'Professional timing equipment for accurate race results' },
        { title: 'Professional Lighting', desc: 'LED lighting system optimized for evening training and competitions' },
        { title: 'Climate Control', desc: 'Indoor facilities with optimal temperature and ventilation' },
      ],
    },
    gallery: {
      heading: 'Facility Gallery',
      subheading: 'Explore our world-class athletics training environment',
    },
    galleryImages: { heading: 'Facility Gallery Images' },
    access: {
      heading: 'Location & How to Get Here',
      address: 'Address',
      addressLine1: 'National Sports Academy',
      addressLine2: 'NSA District',
      addressLine3: 'Sofia, Bulgaria',
      getDirections: 'Get Directions',
      byCar: 'By Car',
      car1: 'Parking available on-site',
      car2: 'Easy access from main roads',
      car3: 'Approximately 10 minutes from Sofia city center',
      byBus: 'By Public Transport',
      bus1: 'Bus lines available',
      bus2: 'Well-connected to Sofia',
      bus3: 'Short walk from bus stops',
      fromAirport: 'From Airport',
      airport1: 'Distance: Approximately 10 km from Sofia Airport',
      airport2: 'Transfer time: 15-20 minutes by car',
      airport3: 'We provide airport transfer services',
      nearbyLandmarks: 'Nearby Landmarks',
      nearby1: 'Sofia University - 5 min drive',
      nearby2: 'NSA Metro Station - 5 min walk',
    },
    pricing: {
      heading: 'Pricing & Availability',
      flexiblePricing: 'Flexible Pricing Options',
      pricingVaries: 'Pricing varies based on:',
      factors: [
        'Duration of booking (hourly, half-day, full-day)',
        'Season and demand',
        'Track and field areas needed',
        'Additional services required',
        'Equipment rental needs',
        'Coaching and support staff requirements',
      ],
      pricingNote: 'For detailed pricing and package options, please contact us with your specific requirements.',
      whatsIncluded: "What's Included:",
      included: [
        'Track access for specified time',
        'Field events areas access',
        'Locker room facilities',
        'Basic equipment access',
        'Electronic timing systems',
        'On-site staff support',
      ],
      optionalAddons: 'Optional Add-ons:',
      addons: [
        'Professional coaching services',
        'Sports science lab analysis',
        'Extended hours',
        'Equipment rental (javelins, discus, etc.)',
        'Video recording and analysis',
        'Medical support and physiotherapy',
      ],
      requestQuote: 'Request a Quote',
    },
    testimonials: {
      heading: 'What Teams Say About Training Here',
      items: [
        { quote: "The National Sports Academy provided exceptional training facilities for our athletics team. The 400m track is world-class and the professional coaching support was outstanding.", name: "Coach Elena Dimitrova", date: "September 2025" },
        { quote: "Perfect venue for track and field training camps. The synthetic track surface is excellent and the field events areas are well-maintained. Highly recommended for serious athletes.", name: "Michael Johnson", date: "August 2025" },
        { quote: "75 years of history speaks for itself. The NSA facilities are top-tier and the sports science lab provides valuable performance analysis. Our team achieved great results here.", name: "Coach Sarah Williams", date: "July 2025" },
        { quote: "Outstanding training environment with professional-grade facilities. The strength & conditioning gym and recovery facilities are excellent. Perfect for elite-level training.", name: "Coach Hans Mueller", date: "June 2025" },
      ],
    },
    similar: {
      heading: 'Explore Other Locations in Sofia',
      viewDetails: 'View Details',
      locations: [
        { name: 'Sofia, Mladost', location: 'Sofia, Mladost', badge: 'Basketball & Volleyball', description: 'Modern basketball and volleyball training facility', path: '/locations/sofia-mladost' },
        { name: 'Boyana Sports Complex', location: 'Sofia, Boyana', badge: 'Multi-Sport', description: 'Comprehensive multi-sport training facility', path: '/locations/sofia-boyana' },
        { name: 'Plovdiv Aquatic Center', location: 'Plovdiv', badge: 'Swimming', description: 'Olympic-size swimming pool and aquatic center', path: '/locations/plovdiv' },
      ],
    },
    faq: {
      heading: 'Frequently Asked Questions',
      items: [
        { question: 'What is the track specification?', answer: 'The facility features a 400m professional synthetic athletics track meeting IAAF standards, with 8 lanes and optimal surface for all weather conditions.' },
        { question: 'What field events are available?', answer: 'The facility includes dedicated areas for long jump, triple jump, high jump, pole vault, shot put, discus, javelin, and hammer throw, all meeting international competition standards.' },
        { question: 'Is professional coaching available?', answer: 'Yes, the National Sports Academy provides access to professional coaching staff with extensive experience in athletics and track & field disciplines.' },
        { question: 'What are the facility operating hours?', answer: 'The facility operates from 6:00 AM to 10:00 PM daily. Extended hours can be arranged for training camps and competitions upon request.' },
        { question: 'Is there accommodation on-site?', answer: 'As a higher education institution, the NSA may have limited on-site accommodation. We can arrange lodging at nearby 4-star hotels or at our Boyana facility which offers on-site rooms.' },
        { question: 'How far is it from Sofia Airport?', answer: 'The National Sports Academy is approximately 10 km from Sofia Airport, about 15-20 minutes by car. We provide airport transfer services.' },
        { question: 'Can we host competitions here?', answer: 'Absolutely! The facility is equipped for hosting athletics competitions and meets with large stadium seating, electronic timing systems, and all necessary equipment.' },
        { question: 'What sports science facilities are available?', answer: 'The NSA features a state-of-the-art sports science laboratory providing performance analysis, biomechanics assessment, and physiological testing services.' },
        { question: 'Is the facility accessible for people with disabilities?', answer: 'Yes, the facility is wheelchair accessible with appropriate facilities for athletes and spectators with disabilities.' },
        { question: 'Can we use the indoor training facilities?', answer: 'Yes, indoor training facilities are available for use during inclement weather or for specific training needs. These include indoor tracks and training areas.' },
      ],
    },
    cta: {
      heading: 'Ready to Book National Sports Academy?',
      subheading: 'Contact us to reserve your training dates',
      sendInquiry: 'Send a quick inquiry',
      requestInfo: 'Request Information',
      speakWithTeam: 'Speak with our team',
      getCompletePackage: 'Get a complete package',
      bookCompletePackage: 'Book Complete Package',
      ctaCallNow: 'Call Now',
    },
  },
  ar: {
    breadcrumb: { home: 'الرئيسية', locations: 'المواقع', nsa: 'صوفيا، الأكاديمية الوطنية' },
    hero: {
      badge: 'صوفيا، الأكاديمية الوطنية',
      heading: 'الأكاديمية الوطنية للرياضة',
      subheading: 'منشأة تدريب ألعاب قوى وجري وميدان عالمية المستوى',
      athletics: 'ألعاب القوى',
      trackField: 'الجري والميدان',
      district: 'صوفيا، منطقة الأكاديمية الوطنية',
      stadiumSeating: 'مقاعد استاد كبيرة',
      sportsList: 'ألعاب القوى، الجري والميدان',
      stars: '5/5 نجوم',
      bookFacility: 'احجز هذه المنشأة',
    },
    overview: {
      heading: 'نظرة عامة على المنشأة',
      cards: [
        { heading: 'نوع المؤسسة', content: 'الأكاديمية الوطنية للرياضة', subtext: '75 عاماً من التميز في التعليم الرياضي' },
        { heading: 'السعة', content: 'مقاعد استاد كبيرة', subtext: 'مرافق متفرجين احترافية' },
        { heading: 'السطح', content: 'مضمار صناعي احترافي', subtext: 'سطح منافسة بمعيار الاتحاد الدولي لألعاب القوى' },
        { heading: 'الشهادة', content: 'معيار دولي', subtext: 'يلبي متطلبات الاتحاد الدولي لألعاب القوى' },
      ],
    },
    about: {
      heading: 'عن الأكاديمية الوطنية للرياضة',
      description: 'الأكاديمية الوطنية للرياضة (NSA) مؤسسة تعليم عالي متخصصة في بلغاريا بتاريخ 75 عاماً. تقع في صوفيا، وتضم هذه الأكاديمية المرموقة مرافق ألعاب قوى وملاعب تدريب عالمية المستوى مصممة للمنافسة والتدريب على المستوى النخبة.',
      keyHighlights: 'أبرز المميزات',
      highlights: [
        '75 عاماً من التميز في التعليم والتدريب الرياضي',
        'مضمار ألعاب قوى صناعي احترافي 400م (معيار الاتحاد الدولي لألعاب القوى)',
        'مناطق شاملة لألعاب الميدان لجميع التخصصات',
        'مرافق تدريب داخلية للتدريب على مدار العام',
        'صالة رياضية احترافية ومرافق قوة وتكييف',
        'مختبر علوم رياضة حديث',
        'طاقم تدريب احترافي بخبرة واسعة',
        'مرافق تعافي ودعم طبي',
        'مثالي لمعسكرات التدريب والمسابقات وتطوير الرياضيين النخبة',
      ],
      testimonial: '"مؤسسة مرموقة بمرافق عالمية المستوى، مثالية لتدريب ألعاب القوى النخبة والمسابقات الدولية."',
      testimonialAttribution: 'فريق صناع الأبطال',
    },
    sports: {
      heading: 'الرياضات والأنشطة المتاحة',
      athletics: 'ألعاب القوى',
      athleticsDesc: 'مضمار ألعاب قوى صناعي احترافي 400م يلبي معايير الاتحاد الدولي لألعاب القوى مع 8 حارات، سطح مثالي لجميع الظروف الجوية، وأنظمة توقيت إلكترونية.',
      viewSpecs: 'عرض المواصفات',
      hideSpecs: 'إخفاء المواصفات',
      trackSpecs: 'مواصفات المضمار:',
      trackSpecsList: ['طول المضمار: 400م (معيار الاتحاد الدولي لألعاب القوى)', 'حارات: 8 حارات', 'السطح: مضمار صناعي احترافي', 'التوقيت: أنظمة توقيت إلكترونية', 'الطقس: سطح لجميع الأجواء'],
      idealFor: 'مثالي لـ:',
      athleticsIdealFor: ['معسكرات تدريب رياضيين نخبة', 'تحضيرات المنتخبات الوطنية', 'مسابقات دولية', 'أحداث المضمار (عدو سريع، متوسط، طويلة)', 'تدريب ومسابقات التتابع'],
      trackField: 'الجري والميدان',
      trackFieldDesc: 'مناطق شاملة لألعاب الميدان مع مرافق مخصصة لجميع تخصصات الرمي والقفز، تلبي معايير المسابقات الدولية.',
      fieldEventsAvailable: 'ألعاب الميدان المتاحة:',
      fieldEventsList: ['حفر القفز الطويل والوثب الثلاثي', 'مناطق القفز العالي والقفز بالزانة', 'دوائر دفع الجلة والقرص والرمح ورمي المطرقة', 'جميع المناطق تلبي معايير مسابقات الاتحاد الدولي لألعاب القوى', 'معدات واحتياطات أمان احترافية'],
      fieldIdealFor: ['تدريب متخصصي ألعاب الميدان', 'مسابقات متعددة الأحداث (العشاري/السباعي)', 'تطوير المهارات التقنية', 'التحضير للمسابقات', 'برامج تدريب على مدار العام'],
    },
    amenities: {
      heading: 'مرافق وخدمات عالمية المستوى',
      items: [
        { title: 'تدريب احترافي', desc: 'وصول لطاقم تدريب ذي خبرة في ألعاب القوى' },
        { title: 'تخزين المعدات', desc: 'مناطق تخزين آمنة لمعدات ألعاب القوى والممتلكات الشخصية' },
        { title: 'مقاعد الاستاد', desc: 'استاد كبير بمقاعد احترافية للمتفرجين وإطلالات ممتازة' },
        { title: 'موقف سيارات متاح', desc: 'مرافق انتظار مريحة للفرق والزوار' },
        { title: 'صالة قوة وتكييف', desc: 'مرافق صالة رياضية احترافية لتدريب الأداء الرياضي' },
        { title: 'واي فاي متاح', desc: 'إنترنت لاسلكي عالي السرعة في جميع أنحاء المنشأة' },
        { title: 'خدمات كافيتريا', desc: 'مرطبات ووجبات متاحة في الموقع' },
        { title: 'مرافق طبية', desc: 'دعم طبي شامل ومرافق إسعافات أولية' },
        { title: 'مختبر علوم الرياضة', desc: 'مختبر حديث لتحليل الأداء والاختبارات' },
        { title: 'أنظمة توقيت إلكترونية', desc: 'معدات توقيت احترافية لنتائج سباق دقيقة' },
        { title: 'إضاءة احترافية', desc: 'نظام إضاءة LED محسّن للتدريب والمسابقات المسائية' },
        { title: 'التحكم بالمناخ', desc: 'مرافق داخلية بدرجة حرارة وتهوية مثالية' },
      ],
    },
    gallery: {
      heading: 'معرض المنشأة',
      subheading: 'استكشف بيئة تدريب ألعاب القوى عالمية المستوى',
    },
    galleryImages: { heading: 'صور معرض المنشأة' },
    access: {
      heading: 'الموقع وكيفية الوصول',
      address: 'العنوان',
      addressLine1: 'الأكاديمية الوطنية للرياضة',
      addressLine2: 'منطقة الأكاديمية الوطنية',
      addressLine3: 'صوفيا، بلغاريا',
      getDirections: 'الحصول على الاتجاهات',
      byCar: 'بالسيارة',
      car1: 'موقف سيارات متاح في الموقع',
      car2: 'وصول سهل من الطرق الرئيسية',
      car3: 'حوالي 10 دقائق من وسط صوفيا',
      byBus: 'بالنقل العام',
      bus1: 'خطوط حافلات متاحة',
      bus2: 'مترابطة جيداً مع صوفيا',
      bus3: 'مسافة قصيرة سيراً من محطات الحافلات',
      fromAirport: 'من المطار',
      airport1: 'المسافة: حوالي 10 كم من مطار صوفيا',
      airport2: 'وقت النقل: 15-20 دقيقة بالسيارة',
      airport3: 'نوفر خدمات نقل من المطار',
      nearbyLandmarks: 'معالم قريبة',
      nearby1: 'جامعة صوفيا - 5 دقائق بالسيارة',
      nearby2: 'محطة مترو الأكاديمية الوطنية - 5 دقائق سيراً',
    },
    pricing: {
      heading: 'الأسعار والتوفر',
      flexiblePricing: 'خيارات أسعار مرنة',
      pricingVaries: 'تختلف الأسعار حسب:',
      factors: [
        'مدة الحجز (بالساعة، نصف يوم، يوم كامل)',
        'الموسم والطلب',
        'مناطق المضمار والميدان المطلوبة',
        'الخدمات الإضافية المطلوبة',
        'احتياجات تأجير المعدات',
        'متطلبات التدريب وطاقم الدعم',
      ],
      pricingNote: 'للحصول على تفاصيل الأسعار وخيارات الباقات، يرجى الاتصال بنا مع متطلباتك المحددة.',
      whatsIncluded: 'ما الذي يُدرج:',
      included: [
        'وصول للمضمار للوقت المحدد',
        'وصول مناطق ألعاب الميدان',
        'مرافق غرف خلع الملابس',
        'وصول المعدات الأساسية',
        'أنظمة توقيت إلكترونية',
        'دعم الطاقم في الموقع',
      ],
      optionalAddons: 'إضافات اختيارية:',
      addons: [
        'خدمات تدريب احترافية',
        'تحليل مختبر علوم الرياضة',
        'ساعات إضافية',
        'تأجير معدات (رماح، أقراص، إلخ)',
        'تسجيل وتحليل فيديو',
        'دعم طبي وعلاج فيزيائي',
      ],
      requestQuote: 'طلب عرض أسعار',
    },
    testimonials: {
      heading: 'ماذا تقول الفرق عن التدريب هنا',
      items: [
        { quote: 'وفرت الأكاديمية الوطنية للرياضة مرافق تدريب استثنائية لفريق ألعاب القوى لدينا. المضمار 400م عالمي المستوى ودعم التدريب الاحترافي كان متميزاً.', name: 'المدرب إيلينا ديميتروفا', date: 'سبتمبر 2025' },
        { quote: 'مكان مثالي لمعسكرات تدريب الجري والميدان. سطح المضمار الصناعي ممتاز ومناطق ألعاب الميدان صيانتها جيدة. موصى به بشدة للرياضيين الجادين.', name: 'مايكل جونسون', date: 'أغسطس 2025' },
        { quote: '75 عاماً من التاريخ تتحدث عن نفسها. مرافق الأكاديمية الوطنية من الطراز الأول ومختبر علوم الرياضة يوفر تحليلاً قيماً للأداء. حقق فريقنا نتائج رائعة هنا.', name: 'المدرب سارة ويليامز', date: 'يوليو 2025' },
        { quote: 'بيئة تدريب متميزة بمرافق احترافية. صالة القوة والتكييف ومرافق التعافي ممتازة. مثالية للتدريب على المستوى النخبة.', name: 'المدرب هانز مولر', date: 'يونيو 2025' },
      ],
    },
    similar: {
      heading: 'استكشف مواقع أخرى في صوفيا',
      viewDetails: 'عرض التفاصيل',
      locations: [
        { name: 'صوفيا، ملادوست', location: 'صوفيا، ملادوست', badge: 'كرة السلة والطائرة', description: 'منشأة تدريب حديثة لكرة السلة والطائرة', path: '/locations/sofia-mladost' },
        { name: 'المجمع الرياضي بويانا', location: 'صوفيا، بويانا', badge: 'متعدد الرياضات', description: 'منشأة تدريب رياضية شاملة', path: '/locations/sofia-boyana' },
        { name: 'مركز بلوفديف المائي', location: 'بلوفديف', badge: 'السباحة', description: 'مسبح أولمبي ومركز مائي', path: '/locations/plovdiv' },
      ],
    },
    faq: {
      heading: 'الأسئلة الشائعة',
      items: [
        { question: 'ما مواصفات المضمار؟', answer: 'تضم المنشأة مضمار ألعاب قوى صناعي احترافي 400م يلبي معايير الاتحاد الدولي لألعاب القوى، مع 8 حارات وسطح مثالي لجميع الظروف الجوية.' },
        { question: 'ما ألعاب الميدان المتاحة؟', answer: 'تضم المنشأة مناطق مخصصة للقفز الطويل والوثب الثلاثي والقفز العالي والقفز بالزانة ودفع الجلة والقرص والرمح ورمي المطرقة، كلها تلبي معايير المسابقات الدولية.' },
        { question: 'هل يتوفر تدريب احترافي؟', answer: 'نعم، توفر الأكاديمية الوطنية للرياضة الوصول لطاقم تدريب احترافي بخبرة واسعة في ألعاب القوى وتخصصات الجري والميدان.' },
        { question: 'ما ساعات عمل المنشأة؟', answer: 'تعمل المنشأة من 6:00 صباحاً إلى 10:00 مساءً يومياً. يمكن ترتيب ساعات إضافية لمعسكرات التدريب والمسابقات عند الطلب.' },
        { question: 'هل تتوفر إقامة في الموقع؟', answer: 'كمؤسسة تعليم عالي، قد يكون لدى الأكاديمية الوطنية إقامة محدودة في الموقع. يمكننا ترتيب الإقامة في فنادق 4 نجوم قريبة أو في منشأة بويانا لدينا التي توفر غرفاً في الموقع.' },
        { question: 'كم تبعد عن مطار صوفيا؟', answer: 'الأكاديمية الوطنية للرياضة على بعد حوالي 10 كم من مطار صوفيا، نحو 15-20 دقيقة بالسيارة. نوفر خدمات نقل من المطار.' },
        { question: 'هل يمكننا تنظيم مسابقات هنا؟', answer: 'بالتأكيد! المنشأة مجهزة لاستضافة مسابقات واجتماعات ألعاب القوى مع مقاعد استاد كبيرة وأنظمة توقيت إلكترونية وجميع المعدات اللازمة.' },
        { question: 'ما مرافق علوم الرياضة المتاحة؟', answer: 'تضم الأكاديمية الوطنية مختبر علوم رياضة حديثاً يوفر تحليل الأداء وتقييم الميكانيكا الحيوية وخدمات الاختبارات الفسيولوجية.' },
        { question: 'هل المنشأة متاحة لذوي الاحتياجات الخاصة؟', answer: 'نعم، المنشأة متاحة للكراسي المتحركة مع مرافق مناسبة للرياضيين والمتفرجين ذوي الاحتياجات الخاصة.' },
        { question: 'هل يمكننا استخدام مرافق التدريب الداخلية؟', answer: 'نعم، مرافق التدريب الداخلية متاحة للاستخدام أثناء الطقس السيء أو لاحتياجات تدريب محددة. تشمل مضامير داخلية ومناطق تدريب.' },
      ],
    },
    cta: {
      heading: 'مستعد لحجز الأكاديمية الوطنية للرياضة؟',
      subheading: 'اتصل بنا لحجز مواعيد التدريب',
      sendInquiry: 'أرسل استفساراً سريعاً',
      requestInfo: 'طلب معلومات',
      speakWithTeam: 'تحدث مع فريقنا',
      getCompletePackage: 'احصل على باقة كاملة',
      bookCompletePackage: 'احجز الباقة الكاملة',
      ctaCallNow: 'اتصل الآن',
    },
  },
};
